import type { ValidationError } from "class-validator";
import classes from "../classes.module.scss";
import StepEmailProAuthBlocks from "./StepEmailProAuthBlocks";
import StepEmailClientSection from "./StepEmailClientSection";
import type { StepEmailSiteTexts } from "../hooks/useStepEmailSiteTexts";
import type { SsoOauthLoginPresetRow } from "./StepSsoOauthLoginPresetPicker";

type Props = {
	siteTexts: StepEmailSiteTexts;
	showSsoProfessionalBlock: boolean;
	showSsoOauthLoginPresetPicker: boolean;
	ssoOauthLoginPresets: readonly SsoOauthLoginPresetRow[];
	onSsoProfessionalClick: () => void;
	onSsoOauthLoginPresetEmail: (email: string) => void | Promise<void>;
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
	prefilledEmail: string;
};

function StepEmailPanelsInnerView(props: Props): React.JSX.Element {
	const { siteTexts, showSsoProfessionalBlock, showSsoOauthLoginPresetPicker, ssoOauthLoginPresets, onSsoProfessionalClick, onSsoOauthLoginPresetEmail, onSubmit, validationErrors, prefilledEmail } = props;
	return (
		<div className={classes["content"]}>
			<StepEmailProAuthBlocks
				showSsoProfessionalBlock={showSsoProfessionalBlock}
				showSsoOauthLoginPresetPicker={showSsoOauthLoginPresetPicker}
				ssoOauthLoginPresets={ssoOauthLoginPresets}
				ssoOauthLoginPresetSectionTitle={siteTexts.ssoOauthLoginPresetSectionTitleDisplay}
				ssoProTitle={siteTexts.ssoProSectionTitleDisplay}
				ssoProCta={siteTexts.ssoProCtaDisplay}
				onSsoProfessionalClick={onSsoProfessionalClick}
				onSsoOauthLoginPresetEmail={onSsoOauthLoginPresetEmail}
			/>
			<StepEmailClientSection
				title={siteTexts.clientsSectionTitleDisplay}
				onSubmit={onSubmit}
				validationErrors={validationErrors}
				prefilledEmail={prefilledEmail}
				emailPlaceholder={siteTexts.emailPlaceholderDisplay}
				emailLabel={siteTexts.emailLabelDisplay}
				submitCta={siteTexts.submitCtaDisplay}
			/>
		</div>
	);
}

export default function StepEmailPanelsInner(props: Props): React.JSX.Element {
	return <StepEmailPanelsInnerView {...props} />;
}
